import { render } from "./ItemPanel.vue?vue&type=template&id=5e5f33f6"
import script from "./ItemPanel.vue?vue&type=script&lang=js"
export * from "./ItemPanel.vue?vue&type=script&lang=js"

import "./ItemPanel.vue?vue&type=style&index=0&id=5e5f33f6&lang=css"

import exportComponent from "D:\\Kaung\\KaungAdmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__